export const getSortingField = (field) => {
  switch (field) {
    case 'publishedSortable':
      return 'publishedDate';
    case 'status':
      return 'status';
    case 'closingSortable':
      return 'tenderPeriod.endDate';
    case 'emitter':
      return 'procuringEntity.name';
    case 'fromPlatform':
      return 'source.name';
    case 'title':
      return 'title';
    default:
      return 'publishedDate';
  }
};

export const getOppSortingField = (field) => {
  switch (field) {
    case 'name':
      return 'name';
    case 'emitter':
      return 'emitter';
    case 'source':
      return 'source';
    case 'authorId':
      return 'author_id';
    case 'createdAt':
      return 'created_at';
    case 'oppClosingDate':
      return 'end_date';
    default:
      return 'created_at';
  }
};

export const getSortingOrder = (isDescending) => (isDescending ? 'desc' : 'asc');
